import React from 'react';
import { useTranslation } from 'react-i18next'

import EmptyScreen from 'packages/ui/EmptyScreen'

const Ran = () => {
  const { t } = useTranslation();
  return (
    <EmptyScreen icon="square-poll-vertical">{t('ran.table.ran_not_activated')}</EmptyScreen>
  );
};

export default Ran;
